import AnnualPeriodsError from './AnnualPeriodsError';
class AnnualPeriodsCouponExpired extends AnnualPeriodsError {
    promotionalCouponId;
    constructor(promotionalCouponId, options) {
        super('The promotional coupon is expired', options);
        this.promotionalCouponId = promotionalCouponId;
    }
}
export default AnnualPeriodsCouponExpired;
